
import { useEffect, useRef } from "react";
import { useStoreApi } from "@tmsw/powerups.store";
import { useTranslate } from '@tmsw/powerups.intl.legacy.hooks.use-translate';
import { AudioDescriptions } from "@tmsw/powerups.services.audio-descriptions";

export type AudioDescriptionsAnnouncerProps = {};

export function AudioDescriptionsAnnouncer() {

  const { subscribe, getState } = useStoreApi();
  const translate = useTranslate();
  const { descriptionsEnabled, currentDescription } = getState().descriptionsEnabled;
  const audioDescriptionTranslate = translate("descriptionsToggle",  "A11Y_MENU");
  const currentDescriptionRef = useRef(currentDescription);

  useEffect(() => {
    const descEnabledUnsub = subscribe(
      (state) => state.descriptionsEnabled,
      (isEnabled, prevIsEnabled) => {
        console.log("DescriptionPlayback :: toggle descriptionsEnabled", isEnabled, prevIsEnabled);
        if (!AudioDescriptions.isUsingSpeechAPI && isEnabled) {
          /* eslint-disable-next-line no-alert */
          alert("Audio Descriptions require accessibility technology enabled in your device settings");
        }
        AudioDescriptions.speak(`${!isEnabled ? audioDescriptionTranslate?.off?.label : audioDescriptionTranslate?.on?.label}`, false);
      }
    );
    return () => {
      descEnabledUnsub();
    };
  }, [subscribe, audioDescriptionTranslate]);

  useEffect(() => {
    const descChangeUnsub = subscribe(
      (state) => state.currentDescription,
      (curr) => {
        console.log("DescriptionPlayback :: new currentDescription", curr);
        currentDescriptionRef.current = curr;
      }
    );
    return () => {
      descChangeUnsub();
    };
  }, [subscribe]);

  // console.log("DescriptionsPlayback :: descriptionsEnabled", descriptionsEnabled, currentDescriptionRef.current);

  return descriptionsEnabled ? (
    <div aria-live="assertive" role="status" style={{ opacity: 0, pointerEvents: "none", position: "absolute" }}>
      {currentDescriptionRef.current}
    </div>
  ) : (
    null
  );
}
